import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[dropSpecialCharacters]'
})
export class DropSpecialCharactersDirective {
  @HostListener('submit', ['$event']) onSubmit(event: Event) {
    const form = event.target as HTMLFormElement;
    const inputs = form.querySelectorAll('input[dropSpecialCharacters]');

    for (let i = 0; i < inputs.length; i++) {
      const input = inputs[i] as HTMLInputElement;
      const value = input.value;
      const numericValue = value.replace(/\D/g, ''); // Remove todos os caracteres não numéricos

      input.value = numericValue;
    }
  }
}
